import { Component, inject } from '@angular/core';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { IMyDate, MDBModalRef } from 'ng-uikit-pro-standard';
import { API_ENDPOINTS } from '../../../../../../models/enums/endpoints.enum';
import { FormControl } from '@angular/forms';
import { TransportOrderExtendedService } from 'services/transport-order-extended.service';
import { mapAsBody } from '../../../../util/request-util';
import dayjs from 'dayjs';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-modal-confirm-delivery',
  templateUrl: './bary-modal-confirm-delivery.component.html',
  styleUrls: ['./bary-modal-confirm-delivery.component.scss'],
})
export class BaryModalConfirmDeliveryComponent {
  readonly modalRef = inject(MDBModalRef);
  readonly transportOrderService = inject(TransportOrderExtendedService);

  public transportOrderId!: number;

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public podURL = API_ENDPOINTS.CONFIRM_DELIVERY;
  public controls = {
    podControl: new FormControl(),
    picturePreview: new FormControl(),
    deliveryDate: new FormControl(new Date()),
  };
  public minDate = dayjs().set('year', 2019).set('month', 0).set('day', 1);
  public dateOption: { minDate: IMyDate; maxDate: IMyDate; disableUntilDate: IMyDate } = {
    minDate: { year: this.minDate.year(), month: this.minDate.month() - 1, day: this.minDate.date() },
    maxDate: { year: dayjs().year() + 1, month: 12, day: 31 },
    disableUntilDate: { year: this.minDate.year(), month: this.minDate.month() - 1, day: this.minDate.date() },
  };

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(from: any): void {
    if (from.submit) {
      this.transportOrderService.confirmDelivery(this.transportOrderId, this.controls.deliveryDate!.value!, this.controls.picturePreview.value).pipe(mapAsBody).subscribe();
    }
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }
}
